<div class="pageWrapper supplier-oms">
  <div class="formsDetails rfq">
    <section class="oms-upper-section">
      <span routerLink="/oms/orders/{{ orderId }}">
        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" />
        </svg>
      </span>
      <h3 class="page-title">Return EDP</h3>
    </section>

    <div class="list_dtl">
      <div>
        <div>
          <div class="rfq_lst_dtl">
            <mat-card class="rfq-card">
              <div class="oms-card-top flex">
                <div class="flex">
                  <span class="oms-po-id">P.O ID : </span>
                  <span class="po-id">{{ orderDetail?.poId }}</span>
                  <span class="po-template">{{ orderDetail?.rfqTemplateType }}</span>
                </div>
                <div class="flex">
                  <span class="oms-status">{{ getEdpStatusLabel(orderDetail?.customerEdp?.edpCustomerStatus) }}</span>
                </div>
              </div>
              <mat-card-header>
                <div class="rfq-title-expiry">
                  <mat-card-title> {{ orderDetail?.projectName }}</mat-card-title>
                  <mat-card-subtitle>
                    <span class="small-font">Order Date : </span>
                    <span class="light-font"> {{ orderDetail?.orderDate }} </span>
                  </mat-card-subtitle>
                </div>
                <div class="rfq-capabilities">
                  <h5 class="rfq-category cate">Category</h5>
                  <ng-container>
                    <span class="capability" *ngFor="let cat of orderDetail?.categories">
                      {{ cat.name }}
                    </span>
                  </ng-container>
                </div>
                <div class="rfq-capabilities">
                  <h5 class="rfq-category cate">Total Quantity</h5>
                  <h5 class="rfq-category">{{ orderDetail?.totalQuantity }}</h5>
                </div>
              </mat-card-header>
              <div class="flex detail_box">
                <div class="rfq-capabilities">
                  <h5 class="rfq-category cate">Due Date</h5>
                  <h5 class="rfq-category due-date">
                    {{ orderDetail?.dueDate | date: "MMM d, y" }}
                  </h5>
                </div>
              </div>
            </mat-card>
          </div>
        </div>
      </div>

      <span class="milestones">Milestones</span>
      <div
        *ngIf="
          orderDetail?.customerEdp?.edpCustomerStatus == EDPStatus.EDP_RECEIVED ||
            orderDetail?.customerEdp?.edpCustomerStatus == EDPStatus.EDP_RETURN;
          else edpData
        "
      >
        <mat-accordion *ngFor="let mile of orderDetail?.customerEdp?.customerMilestones; index as index">
          <mat-expansion-panel [disabled]="mile.state == 'SKIP'">
            <mat-expansion-panel-header #panelH (click)="panelH._toggle()">
              <mat-panel-title>
                <mat-checkbox
                  class="example-margin"
                  (change)="checkMilestones($event.checked, index, mile)"
                  [checked]="mile['freezeCheckbox']"
                  [disabled]="mile['freezeCheckbox']"
                >
                </mat-checkbox>
                <div class="file_name">{{ mile.milestoneName }}</div>
              </mat-panel-title>
              <mat-panel-description>
                <div class="date">
                  <span class="date_label">Start Date</span>
                  <mat-form-field appearance="outline">
                    <input
                      id="modules_rfqmodule_rfqquote_28"
                      matInput
                      [matDatepicker]="picker1"
                      placeholder="DD/MM/YYYY"
                      [(ngModel)]="mile.startDate"
                      [min]="yesterday"
                      (dateChange)="selectedDate($event)"
                      (click)="openDatePicker(picker1)"
                    />
                    <mat-datepicker #picker1></mat-datepicker>
                  </mat-form-field>
                </div>
                <div class="date">
                  <span class="date_label">End Date</span>
                  <mat-form-field appearance="outline">
                    <input
                      id="modules_rfqmodule_rfqquote_28"
                      matInput
                      [matDatepicker]="picker2"
                      placeholder="DD/MM/YYYY"
                      [(ngModel)]="mile.endDate"
                      (click)="openDatePicker(picker2)"
                      [min]="yesterday"
                      (dateChange)="selectedDate($event)"
                    />
                    <mat-datepicker #picker2></mat-datepicker>
                  </mat-form-field>
                </div>
              </mat-panel-description>
            </mat-expansion-panel-header>
          </mat-expansion-panel>
        </mat-accordion>

        <div class="flex detail comment_detail" *ngIf="orderDetail?.customerEdp.customerEdpChats.length != 0">
          <div class="comment_area col-sm-12" *ngFor="let mileChats of orderDetail?.customerEdp.customerEdpChats">
            <ng-container *ngIf="mileChats?.commentBy == 'by'">
              <h3>Remarks</h3>
              <div class="comment_text admin">
                <h4>
                  {{ mileChats?.commentBy }}
                  <span> {{ mileChats?.createdOn | date: "MMM d, y" }}</span>
                </h4>
                <p>{{ mileChats?.comment }}</p>
              </div>
            </ng-container>

            <ng-container *ngIf="mileChats?.commentBy == 'by'">
              <h3>Comment Received from Unibuild</h3>
              <div class="comment_text supplier">
                <h4>
                  {{ mileChats?.commentBy }}
                  <span> {{ mileChats?.createdOn | date: "MMM d, y" }}</span>
                </h4>
                <p>{{ mileChats?.comment }}</p>
              </div>
            </ng-container>
          </div>
        </div>

        <div class="col-sm-12 comment_sec">
          <label> Add Comments </label>
          <mat-form-field appearance="outline">
            <!-- <input matInput placeholder="Add your comments..." /> -->
            <textarea matInput placeholder="Add your comments..."></textarea>
          </mat-form-field>
        </div>
      </div>
      <ng-template #edpData>
        <p>EDP Status is pending</p>
      </ng-template>
    </div>
  </div>
  <div class="bottom-btn">
    <button mat-button class="btnCustom btn-outline">Cancel</button>
    <button mat-button class="btnCustom btn-primary" (click)="confirmReturn()" [disabled]="!isCheckedSelect()">Return</button>
  </div>
</div>
